import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CreatePasswordAdapter } from '../../adapters/create-password/create-password.adapters';
import { LoginModalContent } from '../../models/aem';
import { ResetPasswordFacade } from '../reset-password/reset-password.facade';

@Injectable({
  providedIn: 'root'
})
export class CreatePasswordFacade extends ResetPasswordFacade {
  aemContent!: LoginModalContent;
  unsubscribe: Subject<void> = new Subject<void>();
  isResetPassword = true;
  createPasswordAdapter = inject(CreatePasswordAdapter);

  constructor() {
    super();
    this.getPageContent();
  }

  getPageContent() {
    this.contentService.getAEMContent().subscribe((response) => {
      this.aemContent = response;
      const content = this.createPasswordAdapter.getCreatePasswordContent(
        this.aemContent
      );
      this.resetPasswordContent$.next(content);
    });
  }
}
